export default __webpack_public_path__ + "static/MAM_scrnsht_small-c1d437b5a7791033f06b72502221ab50.jpg";